import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "storage-tab" }
const _hoisted_2 = { class: "storage-selector" }
const _hoisted_3 = { class: "count" }
const _hoisted_4 = { class: "count" }
const _hoisted_5 = { class: "filter-input" }
const _hoisted_6 = { class: "storage-list" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = ["title"]
const _hoisted_9 = { class: "item-type" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = ["onClick"]
const _hoisted_12 = {
  key: 0,
  class: "item-edit"
}
const _hoisted_13 = { class: "edit-actions" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = {
  key: 1,
  class: "item-value"
}
const _hoisted_16 = {
  key: 0,
  class: "empty-state"
}
const _hoisted_17 = { class: "storage-actions" }

import { ref, computed, onMounted, watch } from "vue";

interface StorageItem {
  key: string;
  value: string;
  type: string;
  displayValue: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'StorageTab',
  setup(__props) {

const activeStorage = ref<"localStorage" | "sessionStorage">("localStorage");
const filterText = ref("");
const expandedKeys = ref<string[]>([]);
const editingKey = ref<string | null>(null);
const editValue = ref("");
const localStorageItems = ref<StorageItem[]>([]);
const sessionStorageItems = ref<StorageItem[]>([]);

const localStorageCount = computed(() => localStorageItems.value.length);
const sessionStorageCount = computed(() => sessionStorageItems.value.length);

const currentItems = computed(() => {
  return activeStorage.value === "localStorage" ? localStorageItems.value : sessionStorageItems.value;
});

const filteredItems = computed(() => {
  if (!filterText.value) return currentItems.value;
  const filter = filterText.value.toLowerCase();
  return currentItems.value.filter((item) => item.key.toLowerCase().includes(filter));
});

const parseStorageItem = (key: string, value: string): StorageItem => {
  let type = "string";
  let displayValue = value;

  try {
    const parsed = JSON.parse(value);
    if (typeof parsed === "object" && parsed !== null) {
      type = Array.isArray(parsed) ? "array" : "object";
      displayValue = JSON.stringify(parsed, null, 2);
    } else if (typeof parsed === "number") {
      type = "number";
    } else if (typeof parsed === "boolean") {
      type = "boolean";
    }
  } catch {
    // Keep as string
  }

  return { key, value, type, displayValue };
};

const loadStorage = (storage: Storage): StorageItem[] => {
  const items: StorageItem[] = [];
  for (let i = 0; i < storage.length; i++) {
    const key = storage.key(i);
    if (key) {
      const value = storage.getItem(key) || "";
      items.push(parseStorageItem(key, value));
    }
  }
  return items.sort((a, b) => a.key.localeCompare(b.key));
};

const refreshStorage = () => {
  localStorageItems.value = loadStorage(localStorage);
  sessionStorageItems.value = loadStorage(sessionStorage);
};

const toggleExpand = (key: string) => {
  const index = expandedKeys.value.indexOf(key);
  if (index === -1) {
    expandedKeys.value.push(key);
  } else {
    expandedKeys.value.splice(index, 1);
  }
};

const deleteItem = (key: string) => {
  const storage = activeStorage.value === "localStorage" ? localStorage : sessionStorage;
  storage.removeItem(key);
  refreshStorage();
};

const startEdit = (item: StorageItem) => {
  editingKey.value = item.key;
  editValue.value = item.type === "object" || item.type === "array" ? item.displayValue : item.value;
  if (!expandedKeys.value.includes(item.key)) {
    expandedKeys.value.push(item.key);
  }
};

const cancelEdit = () => {
  editingKey.value = null;
  editValue.value = "";
};

const saveEdit = (key: string) => {
  const storage = activeStorage.value === "localStorage" ? localStorage : sessionStorage;
  const trimmed = editValue.value.trim();
  let valueToStore = editValue.value;

  if (trimmed) {
    try {
      const parsed = JSON.parse(trimmed);
      if (parsed !== null && typeof parsed === "object") {
        valueToStore = JSON.stringify(parsed);
      }
    } catch {
      // Keep as string
    }
  }

  storage.setItem(key, valueToStore);
  refreshStorage();
  cancelEdit();
};

const clearCurrentStorage = () => {
  if (confirm(`Are you sure you want to clear all ${activeStorage.value} items?`)) {
    const storage = activeStorage.value === "localStorage" ? localStorage : sessionStorage;
    storage.clear();
    refreshStorage();
  }
};

onMounted(() => {
  refreshStorage();
});

watch(activeStorage, () => {
  cancelEdit();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        class: _normalizeClass(["storage-btn", { active: activeStorage.value === 'localStorage' }]),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (activeStorage.value = 'localStorage'))
      }, [
        _cache[4] || (_cache[4] = _createTextVNode(" localStorage ", -1)),
        _createElementVNode("span", _hoisted_3, _toDisplayString(localStorageCount.value), 1)
      ], 2),
      _createElementVNode("button", {
        class: _normalizeClass(["storage-btn", { active: activeStorage.value === 'sessionStorage' }]),
        onClick: _cache[1] || (_cache[1] = ($event: any) => (activeStorage.value = 'sessionStorage'))
      }, [
        _cache[5] || (_cache[5] = _createTextVNode(" sessionStorage ", -1)),
        _createElementVNode("span", _hoisted_4, _toDisplayString(sessionStorageCount.value), 1)
      ], 2)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _cache[6] || (_cache[6] = _createElementVNode("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        "stroke-width": "2",
        width: "14",
        height: "14"
      }, [
        _createElementVNode("circle", {
          cx: "11",
          cy: "11",
          r: "8"
        }),
        _createElementVNode("path", { d: "m21 21-4.3-4.3" })
      ], -1)),
      _withDirectives(_createElementVNode("input", {
        type: "text",
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((filterText).value = $event)),
        placeholder: "Filter by key..."
      }, null, 512), [
        [_vModelText, filterText.value]
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredItems.value, (item) => {
        return (_openBlock(), _createElementBlock("div", {
          key: item.key,
          class: _normalizeClass(["storage-item", { expanded: expandedKeys.value.includes(item.key) }])
        }, [
          _createElementVNode("div", {
            class: "item-header",
            onClick: ($event: any) => (toggleExpand(item.key))
          }, [
            _cache[9] || (_cache[9] = _createElementVNode("svg", {
              viewBox: "0 0 24 24",
              fill: "none",
              stroke: "currentColor",
              "stroke-width": "2",
              width: "12",
              height: "12",
              class: "chevron"
            }, [
              _createElementVNode("path", { d: "m9 18 6-6-6-6" })
            ], -1)),
            _createElementVNode("span", {
              class: "item-key",
              title: item.key
            }, _toDisplayString(item.key), 9, _hoisted_8),
            _createElementVNode("span", _hoisted_9, _toDisplayString(item.type), 1),
            _createElementVNode("button", {
              class: "edit-btn",
              onClick: _withModifiers(($event: any) => (startEdit(item)), ["stop"]),
              title: "Edit value"
            }, [...(_cache[7] || (_cache[7] = [
              _createElementVNode("svg", {
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "currentColor",
                "stroke-width": "2",
                width: "12",
                height: "12"
              }, [
                _createElementVNode("path", { d: "M12 20h9" }),
                _createElementVNode("path", { d: "M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4Z" })
              ], -1)
            ]))], 8, _hoisted_10),
            _createElementVNode("button", {
              class: "delete-btn",
              onClick: _withModifiers(($event: any) => (deleteItem(item.key)), ["stop"]),
              title: "Delete"
            }, [...(_cache[8] || (_cache[8] = [
              _createElementVNode("svg", {
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "currentColor",
                "stroke-width": "2",
                width: "12",
                height: "12"
              }, [
                _createElementVNode("path", { d: "M18 6 6 18" }),
                _createElementVNode("path", { d: "m6 6 12 12" })
              ], -1)
            ]))], 8, _hoisted_11)
          ], 8, _hoisted_7),
          (editingKey.value === item.key)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _withDirectives(_createElementVNode("textarea", {
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((editValue).value = $event)),
                  class: "edit-input",
                  rows: "5"
                }, null, 512), [
                  [_vModelText, editValue.value]
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("button", {
                    class: "edit-action-btn",
                    onClick: ($event: any) => (saveEdit(item.key))
                  }, "Save", 8, _hoisted_14),
                  _createElementVNode("button", {
                    class: "edit-action-btn ghost",
                    onClick: cancelEdit
                  }, "Cancel")
                ])
              ]))
            : _createCommentVNode("", true),
          (expandedKeys.value.includes(item.key) && editingKey.value !== item.key)
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                _createElementVNode("pre", null, _toDisplayString(item.displayValue), 1)
              ]))
            : _createCommentVNode("", true)
        ], 2))
      }), 128)),
      (filteredItems.value.length === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
            _cache[10] || (_cache[10] = _createElementVNode("svg", {
              viewBox: "0 0 24 24",
              fill: "none",
              stroke: "currentColor",
              "stroke-width": "2",
              width: "24",
              height: "24"
            }, [
              _createElementVNode("rect", {
                width: "20",
                height: "5",
                x: "2",
                y: "3",
                rx: "1"
              }),
              _createElementVNode("path", { d: "M4 8v11a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8" }),
              _createElementVNode("path", { d: "M10 12h4" })
            ], -1)),
            _createElementVNode("span", null, _toDisplayString(filterText.value ? "No matching items" : "Storage is empty"), 1)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_17, [
      _createElementVNode("button", {
        class: "action-btn",
        onClick: refreshStorage
      }, [...(_cache[11] || (_cache[11] = [
        _createElementVNode("svg", {
          viewBox: "0 0 24 24",
          fill: "none",
          stroke: "currentColor",
          "stroke-width": "2",
          width: "12",
          height: "12"
        }, [
          _createElementVNode("path", { d: "M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8" }),
          _createElementVNode("path", { d: "M3 3v5h5" })
        ], -1),
        _createTextVNode(" Refresh ", -1)
      ]))]),
      _createElementVNode("button", {
        class: "action-btn danger",
        onClick: clearCurrentStorage
      }, [
        _cache[12] || (_cache[12] = _createElementVNode("svg", {
          viewBox: "0 0 24 24",
          fill: "none",
          stroke: "currentColor",
          "stroke-width": "2",
          width: "12",
          height: "12"
        }, [
          _createElementVNode("path", { d: "M3 6h18" }),
          _createElementVNode("path", { d: "M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6" }),
          _createElementVNode("path", { d: "M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2" })
        ], -1)),
        _createTextVNode(" Clear " + _toDisplayString(activeStorage.value === "localStorage" ? "Local" : "Session"), 1)
      ])
    ])
  ]))
}
}

})